export default __webpack_public_path__ + "static/media/LoadingGif.2f0955ef.gif";